import { n as numeric10Values } from './values-D-xU0n7p.js';

const defaultOptions = [{
  id: 'veryDissatisfied',
  label: 'Very dissatisfied'
}, {
  id: 'dissatisfied',
  label: 'Dissatisfied'
}, {
  id: 'neitherSatisfiedNorDissatisfied',
  label: 'Neither satisfied nor dissatisfied'
}, {
  id: 'satisfied',
  label: 'Satisfied'
}, {
  id: 'verySatisfied',
  label: 'Very satisfied'
}];
const numeric10Options = numeric10Values.map(value => ({
  id: `${value}`,
  label: `${value} out of 10`
}));

export { defaultOptions as d, numeric10Options as n };
//# sourceMappingURL=defaultOptions-pw1XHNfj.js.map
